import { AppGlobals } from 'src/app/app.global';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { CustomerModel, PlantInformationWithGSTNoModel, TopManagementModel, AttachmentModel, ContactPersonDetailsModel } from 'src/app/Model/CustomerModel';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/common.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';

import { FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { AccessPermissionModel } from 'src/app/Model/WorkFlowScreenAccessModel';
import { AccessPermissionService } from 'src/app/Service/access-permission.service';

@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.scss']
})
export class AddCustomerComponent implements OnInit {
  accesspermissionobj:AccessPermissionModel[]=Array<AccessPermissionModel>();
  AccesspermissionForRole:any[]=[];

  CustomerModel: CustomerModel = new CustomerModel();
  emailPattern: string = "^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$";
  urlPattern_old: string = "^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$";
  urlPattern: string = "(https?://)?([\da-z.-]+)\.([a-z.]{2,6})[/\w .-]*/?";
  charCode: any;
  Country: any[] = [];
  Region: any[] = [];
  IndustrySegment: any[] = [];
  CustomerClassification: any[] = [];
  CustomerCategory: any[] = [];
  Typeofcustomer: any[] = [];
  SubSegment: any[] = [];
  InvalidExtension: boolean;
  CustomerGroup: any[] = []; //for customer group & code
  CustomerGroupCode: any[] = []; //for customer group  & code
  fileType: any[] = ['image/bmp', 'image/jpeg', 'image/png', 'application/pdf', 'text/plain', 'text/csv', 'application/xml', 'text/xml',
    'application/msword', 'image/jpg', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/zip', 'application/x-zip-compressed', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'];

  KYCfileType: any[] = ['text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
  KYC1fileType: any[] = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
  tempCorporatePresentation: any;
  tempOrganogram: any;
  tempKYC1: any;
  tempKYC2: any;
  tempKYC3: any;
  PlantInformationWithGSTNoobj: PlantInformationWithGSTNoModel = new PlantInformationWithGSTNoModel();
  TopmanagementObj: TopManagementModel = new TopManagementModel();
  KeymanagementObj: ContactPersonDetailsModel = new ContactPersonDetailsModel();
  FirstcontacttechnicalObj: ContactPersonDetailsModel = new ContactPersonDetailsModel();
  FirstcontactcommercialObj: ContactPersonDetailsModel = new ContactPersonDetailsModel();
  Attachmentobj: AttachmentModel = new AttachmentModel();
  KYC1Attachment: any;
  @Input()
  showLoader: boolean = false;
  plant: any;

  fileUrl = AppGlobals.baseFileDownloadUrl + "KYC/KYCTemplate.xlsx";
  //fileUrl = AppGlobals.baseFileDownloadUrl + "KYC/UpgatedKYCTemplate.xlsx";
  fileUploadForm: FormGroup;
  fileInputLabel: string;
  myfile: string;
  uploadedData: any;
  industrySeg: any;
  subseg: any;
  customerClass: any;
  custCategory: any;
  custType: any;
  tempRegion: any;
  plantRegion: any;
  countryName: any;
  customergroupName: any; //for customer group  & code
  customergroupCode: any; //for customer group  & code
  remLimit: any = 1500;
  maxLimit: any = 1500;
  varLongTermGoal: any;
  UserRole: any;
  isCustomerEditable: boolean = false;
  type:any;
  constructor(private router: Router, private toastr: ToastrService, private Service: CommonService,
    public dialog: MatDialog, private route: ActivatedRoute, private titleService: Title,private accessservice: AccessPermissionService) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.route.snapshot.data['title'] + " - WEISS");
    //this.GetCustomerCode();
   // this.GetCustomerDropdownData();
    this.UserRole = localStorage.getItem("UserRole");
    this.getAccess();
    //this.isCustomerEditable = AppGlobals.CustomerMastersEditableAccessArray.filter(x => x.role == this.UserRole)[0]?.isEditable;
    this.CustomerModel.BasicCustomerInformationModel.Id = this.route.snapshot.params["id"];
    this.type = this.route.snapshot.params["type"];
    this.GetCustomerDropdownData();
    if(this.type=='lead')
    {
      this.getLeadDetailsById(this.CustomerModel.BasicCustomerInformationModel.Id);
    }
  }

  getLeadDetailsById(leadId: number) {
    this.showLoader = true;

    let queryString = "";
    queryString = "Lead_Id=" + leadId;

    this.Service.GetData('Lead', 'GetLeadByIDForCustomer', queryString).subscribe((data: any) => {
      this.CustomerModel = data;
      if (!this.CustomerModel.KeyManagementPersonDetails || this.CustomerModel.KeyManagementPersonDetails.length === 0) {
        this.CustomerModel.KeyManagementPersonDetails = [new ContactPersonDetailsModel()];
      }
      this.GetSubSegment(this.CustomerModel.CustomerProfile.IndustrySegment);
      this.GetCustomerGroupCode(this.CustomerModel.BasicCustomerInformationModel.CustomergroupId);
      this.showLoader = false;
    }, error => {
      this.toastr.error("Failed to load data!");
      this.showLoader = false;
    });

  }

  /*******************************************************************************
      * Get data for add customer
  * ******************************************************************************/
  // GetCustomerCode() {
  //   this.showLoader = true;
  //   this.Service.GetData("Customer", "GetMaxId", null).subscribe((data: any) => {
  //     //this.CustomerModel.BasicCustomerInformationModel.CustomerCode = data;
  //     this.CustomerCode = data;
  //     this.showLoader = false;
  //   }, error => {
  //     this.toastr.error("Failed to load data!");
  //     this.showLoader = false;
  //   });
  // }

  GetCustomerDropdownData() {
    this.showLoader = true;
    this.Service.GetData("Customer", "GetCustomerDropdownDetails", null).subscribe((data: any) => {
      this.Country = data.Country;
      this.Region = data.Region;
      this.IndustrySegment = data.IndustrySegment;
      this.CustomerCategory = data.CustomerCategory;
      this.CustomerClassification = data.CustomerClassification;
      this.Typeofcustomer = data.CustomerType;
      this.CustomerGroup = data.CustomerGroup; //for customer group  & code
    //  console.log("CustomerGroup array---->",this.CustomerGroup)
      this.showLoader = false;
    }, error => {
      this.toastr.error("Failed to load data!");
      this.showLoader = false;
    });
  }

  GetSubSegment(IndustrySegment: number) {
    this.showLoader = true;

    let queryString = "";
    queryString = "SegmentId=" + IndustrySegment;
    this.Service.GetData("SubSegment", "GetByIndustrySegmentId", queryString).subscribe((data: any) => {
      this.SubSegment = data;
      this.showLoader = false;
    }, error => {
      this.toastr.error("Failed to load data!");
      this.showLoader = false;
    });
  }

  /*******************************************************************************
      * End get data for add customer
  * ******************************************************************************/


  /*******************************************************************************
      * File Upload and Delete section
  * ******************************************************************************/

  CheckFileValidation(File: any, ValidFileType: any[], MaxSize: number) {
    var Result = {
      isExtensionValid: false,
      isSizeValid: false
    };
    let FileType = File.type;
    if ((File.size) / 1000000 <= MaxSize) {
      Result.isSizeValid = true;
      for (var j = 0; j < ValidFileType.length; j++) {
        if (FileType.toLowerCase() == ValidFileType[j]) {
          Result.isExtensionValid = true;
          break;
        }

      }

    }
    else {
      Result.isSizeValid = false;
    }
    return Result;
  }

  NoOfEmp(myform: any) {
    if (this.CustomerModel.CompanyTurnover.Noofemployees == 0 && this.CustomerModel.CompanyTurnover.Noofemployees.toString() != "") {
      myform.controls['noofemployees'].setErrors({ NoGreater: true });
    }
  }

  getfiledetails(e: any) {
    if (e.target.files[0].name.length > 50) {
      e.target.value = null;
      this.toastr.warning("The file name with more than 50 characters are not allowed.");
    }
    else {
      if (e.target.name == "KYC1attachment" || e.target.name == "KYC2attachment" || e.target.name == "KYC3attachment") {
        var KycResult;
        if (e.target.name == "KYC1attachment") {
          KycResult = this.CheckFileValidation(e.target.files[0], this.KYC1fileType, 5);
        }
        else {
          KycResult = this.CheckFileValidation(e.target.files[0], this.KYCfileType, 5);
        }
        if (KycResult.isExtensionValid == true && KycResult.isSizeValid == true) {
          if (e.target.name == "KYC1attachment") {
            this.showLoader = true;
            this.myfile = e.target.files[0];
            const formData = new FormData();
            formData.append('file', this.myfile);

            this.Service.PostData('Customer', 'AddFromFile', formData, null).subscribe((response: any) => {
              if (response == "Invalid file.") {
                this.toastr.warning("Please select valid file.");
              }
              else {
                if (response != null) {
                  this.CustomerModel = response;
                  if (!this.CustomerModel.KeyManagementPersonDetails || this.CustomerModel.KeyManagementPersonDetails.length === 0) {
                    this.CustomerModel.KeyManagementPersonDetails = [new ContactPersonDetailsModel()];
                  }
                  if (this.CustomerModel.CompanyTurnover.GroupTurnoverYear == 0) this.CustomerModel.CompanyTurnover.GroupTurnoverYear = null;
                  if (this.CustomerModel.CompanyTurnover.DomesticTurnoverYear == 0) this.CustomerModel.CompanyTurnover.DomesticTurnoverYear = null;
                  if (this.CustomerModel.CompanyTurnover.ExportTurnoverYear == 0) this.CustomerModel.CompanyTurnover.ExportTurnoverYear = null;
                  if (this.CustomerModel.CompanyTurnover.IndiaunitTurnoverYear == 0) this.CustomerModel.CompanyTurnover.IndiaunitTurnoverYear = null;
                  if (this.CustomerModel.CompanyTurnover.ProjectedTurnoverYear == 0) this.CustomerModel.CompanyTurnover.ProjectedTurnoverYear = null;
                  if (this.CustomerModel.CompanyTurnover.Noofemployees == 0) this.CustomerModel.CompanyTurnover.Noofemployees = null;
                  this.industrySeg = this.IndustrySegment.filter(x => x.Name == this.CustomerModel.CustomerProfile.IndustrySegmentName);
                  if (this.industrySeg.length > 0) { this.CustomerModel.CustomerProfile.IndustrySegment = this.industrySeg[0].Id; }

                  if (this.CustomerModel.CustomerProfile.IndustrySegment != null) {
                    this.showLoader = true;

                    let queryString = "";
                    queryString = "SegmentId=" + this.CustomerModel.CustomerProfile.IndustrySegment;
                    this.Service.GetData("SubSegment", "GetByIndustrySegmentId", queryString).subscribe((data: any) => {
                      this.SubSegment = data;
                      if (this.CustomerModel.CustomerProfile.SubSegmentName != "") {
                        this.subseg = this.SubSegment.filter(x => x.SubSegmentName == this.CustomerModel.CustomerProfile.SubSegmentName);
                        if (this.subseg.length > 0) { this.CustomerModel.CustomerProfile.SubSegment = this.subseg[0].Id; }
                      }
                      this.showLoader = false;
                    }, error => {
                      this.toastr.error("Failed to load data!");
                      this.showLoader = false;
                    });
                  }
                 
                  // for customer grp name & code
                  this.customergroupName = this.CustomerGroup?.filter(x => x.Name == this.CustomerModel.BasicCustomerInformationModel.CustomergroupName);
                  if (this.customergroupName?.length > 0) { this.CustomerModel.BasicCustomerInformationModel.CustomergroupId = this.customergroupName[0].Id; }

                  if (this.CustomerModel.BasicCustomerInformationModel.CustomergroupId != null) {
                    this.showLoader = true;

                    var queryString ;
                    queryString = this.CustomerModel.BasicCustomerInformationModel.CustomergroupId;
                    this.CustomerGroupCode = this.CustomerGroup?.filter(x => x.Id == queryString);
                    
                      if (this.CustomerModel.BasicCustomerInformationModel.CustomergroupCode != "") 
                      {
                        this.customergroupCode = this.CustomerGroupCode?.filter(x => x.Value == this.CustomerModel.BasicCustomerInformationModel.CustomergroupCode);
                        if (this.customergroupCode.length > 0) { this.CustomerModel.BasicCustomerInformationModel.CustomergroupId = this.customergroupCode[0].Id; }
                      }
                      else{
                      this.toastr.error("Failed to load data!");
                      }
                      this.showLoader = false;
                  }
                 
                  if (this.CustomerModel.CustomerProfile.CustomerClassificationName != "") {
                    this.customerClass = this.CustomerClassification?.filter(x => x.Name == this.CustomerModel.CustomerProfile.CustomerClassificationName);
                    if (this.customerClass.length > 0) { this.CustomerModel.CustomerProfile.CustomerClassification = this.customerClass[0].Id; }
                  }

                  if (this.CustomerModel.CustomerProfile.CustomerCategoryName != "") {
                    this.custCategory = this.CustomerCategory?.filter(x => x.Name == this.CustomerModel.CustomerProfile.CustomerCategoryName);
                    if (this.custCategory.length > 0) { this.CustomerModel.CustomerProfile.CustomerCategory = this.custCategory[0].Id; }
                  }

                  if (this.CustomerModel.CustomerProfile.TypeofcustomerName != "") {
                    this.custType = this.Typeofcustomer.filter(x => x.Name == this.CustomerModel.CustomerProfile.TypeofcustomerName);
                    if (this.custType.length > 0) { this.CustomerModel.CustomerProfile.Typeofcustomer = this.custType[0].Id; }
                  }

                  if (this.CustomerModel.WINWSEAContactDetails.RegionName != "") {
                    this.tempRegion = this.Region.filter(x => x.Name == this.CustomerModel.WINWSEAContactDetails.RegionName);
                    if (this.tempRegion.length > 0) { this.CustomerModel.WINWSEAContactDetails.Region = this.tempRegion[0].Id; }
                  }

                  // if()
                  // this.customerClass = this.CustomerClassification.filter(x => x.Name == this.CustomerModel.CustomerProfile.CustomerClassificationName);
                  // if (this.customerClass.length > 0) { this.CustomerModel.CustomerProfile.CustomerClassification = this.customerClass[0].Id; }
                  if (this.CustomerModel.BasicCustomerInformationModel.CountryName != "") {
                    this.countryName = this.Country.filter(x => x.Name == this.CustomerModel.BasicCustomerInformationModel.CountryName);
                    if (this.countryName.length > 0) { this.CustomerModel.BasicCustomerInformationModel.Country = this.countryName[0].Id; }
                  }


                  let i = 0;
                  this.CustomerModel.PlantInformationWithGSTNo.forEach(element => {
                    this.plantRegion = this.Region.filter(x => x.Name == element.RegionName);
                    if (this.plantRegion.length > 0) { this.CustomerModel.PlantInformationWithGSTNo[i].Region = this.plantRegion[0].Id; }
                    i++;
                  });


                }
              }
              this.showLoader = false;
            }, error => {
              this.toastr.error('Failed to load data!');
              this.showLoader = false;

            });
          }
          else if (e.target.name == "KYC2attachment") {
            this.Attachmentobj.KYC2Attachment = e.target.files[0];
          }
          else if (e.target.name == "KYC3attachment") {
            this.Attachmentobj.KYC3Attachment = e.target.files[0];
          }

        }
        else if (KycResult.isSizeValid == false) {
          e.target.value = null;
          this.toastr.warning("File size must be less than or equal to 5MB!");
        }
        else if (KycResult.isExtensionValid == false) {
          e.target.value = null;
          if (e.target.name == "KYC1attachment") {
            this.toastr.warning("Please attach the file having extension :\n\n .xlsx");
          }
          else {
            this.toastr.warning("Please attach the file having extension :\n\n .xls, .xlsx");
          }
        }

      }

      else {
        var Result = this.CheckFileValidation(e.target.files[0], this.fileType, 5)
        if (Result.isExtensionValid == true && Result.isSizeValid == true) {
          if (e.target.name == "corppresentation") {
            this.Attachmentobj.CorporatePresentationAttachment = e.target.files[0];
          }
          else if (e.target.name == "organogram") {
            this.Attachmentobj.OrganogramAttachment = e.target.files[0];
          }

        }
        else if (Result.isSizeValid == false) {
          e.target.value = null;
          this.toastr.warning("File size must be less than or equal to 5MB!");
        }
        else if (Result.isExtensionValid == false) {
          e.target.value = null;
          this.toastr.warning("Please attach the file having extension :\n\n .bmp, .jpeg, .jpg, .png, .pdf, .xml, .txt, .doc, .docx, .zip, .ppt, .pptx");
        }

      }
    }
  }

  DeleteAttachments(Type: any) {
    switch (Type) {
      case "corppresentation":
        this.Attachmentobj.CorporatePresentationAttachment = null;
        break;
      case "organogram":
        this.Attachmentobj.OrganogramAttachment = null;
        break;
      case "KYC2attachment":
        this.Attachmentobj.KYC2Attachment = null;
        break;
      case "KYC3attachment":
        this.Attachmentobj.KYC3Attachment = null;
        break;
      case "KYC1attachment":
        this.KYC1Attachment = null;
        break;
    }
  }

  /*******************************************************************************
        * End File Upload section
    * ******************************************************************************/
  OnselectIndustrySegment(event: any) {
    this.CustomerModel.CustomerProfile.SubSegment = null;
    this.GetSubSegment(event.target.value);
  }

  //for customer grp name & code
  OnselectCustomerGroupName(event: any) {
    //this.CustomerModel.BasicCustomerInformationModel.CustomergroupId = null;
    this.GetCustomerGroupCode(event.target.value);
    
  }

  GetCustomerGroupCode(CustomerGroupId: number) {
    this.CustomerModel.BasicCustomerInformationModel.CustomergroupCode = null;
   this.CustomerGroupCode = this.CustomerGroup.filter(x => x.Id == CustomerGroupId);
  // console.log("After CustomerGroupName change---->",this.CustomerGroupCode);
   
   }
  /*******************************************************************************
   * Form validation method
   * ******************************************************************************/

  isNumberKey(evt: any) {
    this.charCode = (evt.which) ? evt.which : evt.keyCode;
    if (this.charCode != 46 && this.charCode > 31
      && (this.charCode < 48 || this.charCode > 57)) {
      return false;
    }
    else {
      return true;
    }
  }

  AvoidSpace(event: any) {
    if (event.which === 32 && !event.target.value.length) {
      event.preventDefault();
    }
  }

  PercentageShareValidation(myform: any) {
    if (this.CustomerModel.FinancialDetails.PercentageShare > 100) {
      myform.controls['percentageshare'].setErrors({ PercentageGreater: true });
    }
  }
  /*******************************************************************************
   * End Form validation method 
   * ******************************************************************************/

  /*******************************************************************************
  * Add multiple filed (Dynamic grid)
  * ******************************************************************************/
  AddNewRow(Type: any) {

    if (Type == 'Submitted') {
      if (this.PlantInformationWithGSTNoobj.CompanyName != "" || this.PlantInformationWithGSTNoobj.Region != null || this.PlantInformationWithGSTNoobj.Address != "" || this.PlantInformationWithGSTNoobj.GSTNo != "" ||
        this.PlantInformationWithGSTNoobj.KeyAccountNo != "" || this.PlantInformationWithGSTNoobj.ContactNo != "" || this.PlantInformationWithGSTNoobj.Email != "") {
        this.CustomerModel.PlantInformationWithGSTNo.push(this.PlantInformationWithGSTNoobj);
        this.PlantInformationWithGSTNoobj = new PlantInformationWithGSTNoModel();
      }
      if (this.TopmanagementObj.Name != "" || this.TopmanagementObj.Designation != "" || this.TopmanagementObj.ContactNo != "" || this.TopmanagementObj.Email != "") {
        this.CustomerModel.TopManagement.push(this.TopmanagementObj);
        this.TopmanagementObj = new TopManagementModel();
      }
      if (this.FirstcontacttechnicalObj.Name != "" || this.FirstcontacttechnicalObj.ContactNo != "" || this.FirstcontacttechnicalObj.MailAddress != "") {
        this.CustomerModel.FirstContactTechnicalPersonDetails.push(this.FirstcontacttechnicalObj);
        this.FirstcontacttechnicalObj = new ContactPersonDetailsModel();
      }
      if (this.FirstcontactcommercialObj.Name != "" || this.FirstcontactcommercialObj.ContactNo != "" || this.FirstcontactcommercialObj.MailAddress != "") {
        this.CustomerModel.FirstContactCommercialPersonDetails.push(this.FirstcontactcommercialObj);
        this.FirstcontactcommercialObj = new ContactPersonDetailsModel();
      }

    }
    else {

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: {
          title: "Are you sure?",
          message: "Do you want to add another row for entering remaining details?"
        }
      });

      dialogRef.afterClosed().subscribe(dialogResult => {

        if (dialogResult) {
          if (Type == 'Plant') {
            if (Object.keys(this.PlantInformationWithGSTNoobj).length > 0) {
              this.CustomerModel.PlantInformationWithGSTNo.push(this.PlantInformationWithGSTNoobj);
              this.PlantInformationWithGSTNoobj = new PlantInformationWithGSTNoModel();
            }
          }
          if (Type == 'TopManagement') {
            if (Object.keys(this.TopmanagementObj).length > 0) {
              this.CustomerModel.TopManagement.push(this.TopmanagementObj);
              this.TopmanagementObj = new TopManagementModel();
            }
          }
          if (Type == 'TechnicalContact') {
            if (Object.keys(this.FirstcontacttechnicalObj).length > 0) {
              this.CustomerModel.FirstContactTechnicalPersonDetails.push(this.FirstcontacttechnicalObj);
              this.FirstcontacttechnicalObj = new ContactPersonDetailsModel();
            }
          }
          if (Type == 'CommercialContact') {
            if (Object.keys(this.FirstcontactcommercialObj).length > 0) {
              this.CustomerModel.FirstContactCommercialPersonDetails.push(this.FirstcontactcommercialObj);
              this.FirstcontactcommercialObj = new ContactPersonDetailsModel();
            }
          }
        }

      });

    }

  }

  deleteField(index: any, Type) {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: {
        title: "Are you sure?",
        message: "Do you want to delete this record?"
      }
    });

    dialogRef.afterClosed().subscribe(dialogResult => {

      if (dialogResult) {
        if (Type == 'Plant') {
          this.CustomerModel.PlantInformationWithGSTNo.splice(index, 1);
        }
        if (Type == 'TopManagement') {
          this.CustomerModel.TopManagement.splice(index, 1);
        }
        if (Type == 'TechnicalContact') {
          this.CustomerModel.FirstContactTechnicalPersonDetails.splice(index, 1);
        }
        if (Type == 'CommercialContact') {
          this.CustomerModel.FirstContactCommercialPersonDetails.splice(index, 1);
        }
      }
    });
  }

  /*******************************************************************************
   * End - add multiple filed (Dynamic grid)
   * ******************************************************************************/

  onSubmit(myform: any) {

    if(this.type=='lead')
    {
      this.CustomerModel.BasicCustomerInformationModel.leadId=this.route.snapshot.params["id"];
      
    }
    if (this.CustomerModel.FinancialDetails.PercentageShare > 100) {
      myform.controls['percentageshare'].setErrors({ PercentageGreater: true });
    }
    else {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: {
          title: "Are you sure?",
          message: "Do you want to add this customer?"
        }
      });
      if (this.CustomerModel.CompanyTurnover.Noofemployees == 0 && this.CustomerModel.CompanyTurnover.Noofemployees.toString() != "") {
        myform.controls['noofemployees'].setErrors({ NoGreater: true });
      }

      dialogRef.afterClosed().subscribe(dialogResult => {

        if (dialogResult) {

          this.AddNewRow('Submitted');
          // this.CustomerModel.BasicCustomerInformationModel.CustomerCode = this.CustomerCode;
          const frmData = new FormData();
          frmData.append("KYC2Attachment", this.Attachmentobj.KYC2Attachment);
          frmData.append("KYC3Attachment", this.Attachmentobj.KYC3Attachment);
          frmData.append("CorporatePresentationAttachment", this.Attachmentobj.CorporatePresentationAttachment);
          frmData.append("OrganogramAttachment", this.Attachmentobj.OrganogramAttachment);
          let CustomerDetails = JSON.stringify(this.CustomerModel);
          frmData.append("CustomerModel", CustomerDetails);
          this.showLoader = true;
          this.Service.PostData('Customer', 'Add', frmData, null).subscribe((data: any) => {
            let result = data;
            this.showLoader = false;
            if (result.ResponseCode == 1) {
              this.toastr.success('Customer details added successfully!');
              //this.router.navigate(['/Customer']);
              this.goBack();
            }
            else {
              this.toastr.error("Failed to add customer details!");
              this.showLoader = false;
            }

          }, error => {
            this.toastr.error('Failed to add customer details!');
            this.showLoader = false;
            this.goBack()
          });
        }
      });

    }

  }
  limitTextOnKeyUpDown1(event: any) {
    let goalText = event.target.value;
    if (goalText.length > this.maxLimit) {
      this.varLongTermGoal = goalText.substring(0, this.maxLimit);
    } else {
      this.remLimit = this.maxLimit - goalText.length;
    }
  }
  goBack()
  {
    if(this.type=="customer")
    {
      this.router.navigate(['/Customer']);
    }
    else{
      this.router.navigate(['/Lead']);
    }
  }

  getAccess()
  {
    this.accessservice.GetAll().subscribe((data:any)=> {
      this.accesspermissionobj=data;
      this.isCustomerEditable=this.accesspermissionobj.filter(x => x.Fk_RoleId == this.UserRole && x.ElementKey=='isCustomer')[0]?.IsEditable;
      
    });
 
  }

}
